<template>
  <sui-segment raised>
    <sui-message error v-if="error">
      <h3>{{ $t('strError') }}</h3>
      {{ error }}
    </sui-message>
    <BuyForm v-if="step==0" v-bind:current="current" v-on:goNext="stepUp" />
    <CheckForm v-if="step==1" v-bind:current="current" v-on:goBack="stepDown" />
    <sui-dimmer :active="loading">
      <sui-loader>{{ $t('strLoading') }}</sui-loader>
    </sui-dimmer>
  </sui-segment>
</template>

<script>
  import BuyForm from '@/views/components/BuyForm.vue'
  import CheckForm from '@/views/components/CheckForm.vue'

  export default {
    name: 'Detail',
    components: {
      BuyForm,
      CheckForm
    },
    metaInfo() {
      return {
        title: 'LAN1 Voucher Shop | ' + this.$t(this.$store.getters.currentVoucher.name),
      }
    },
    data() {
      return {
        error: '',
        loading: true,
        step: 0,
        current: {
          mail: null,
          smsEnable: 0,
          smsPrefix: '+49',
          smsValue: null,
          company: null,
          firstName: null,
          lastName: null,
          street: null,
          zip: null,
          city: null,
          acceptConditions: 0,
          acceptPrivacy: 0,
        }
      }
    },
    methods: {
      stepUp() {
        this.step = 1;
      },
      stepDown() {
        this.step = 0;
      }
    },
    async created() {
      let item = this.$store.getters.currentVoucher
      if (item && item.id && item.id == this.$route.params.id) {
        this.loading = false
      } else {
        await this.$store.dispatch('fetchVouchers')
        this.loading = false
        if (this.$store.getters.errorMsg) {
          this.$swal(this.$t('error'), this.$t(this.$store.getters.errorMsg), 'error')
        } else {
          this.$store.commit('SELECT_VOUCHER', this.$route.params.id)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
